// extracted by mini-css-extract-plugin
export default {"activity-row":"ActivityStatus_activity-row__ZWSOt","status-text":"ActivityStatus_status-text__Vw5Ai","status-text-inactive":"ActivityStatus_status-text-inactive__D957b"};